export enum ErrorCode {
  INVALID_PROFILE = 0,
  TOKEN_EXPIRED = 1,
  UNKNOWN_ERROR = 2,
  CAMERA_ERROR = 3,
  INTERNAL_ERROR = 4,
  SESSION_NOT_ALLOWED = 5,
  USER_CANCELLED = 6,
  SDK_STATE_FAILED = 7,
  NETWORK_ERROR = 8,
  SCAN_ERROR = 9
}